import React from 'react';

const Pyramid = () => <div>Pyramid</div>;

export default Pyramid;
